import { render, staticRenderFns } from "./ConnectMessageTemplate.vue?vue&type=template&id=32a0fda6&scoped=true&lang=pug&"
import script from "./ConnectMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./ConnectMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ConnectMessageTemplate.vue?vue&type=style&index=0&id=32a0fda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0fda6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VChip,VTextarea})
